import React from 'react';
import { WrappedCard } from '../WrappedCard';
import { wrappedCopy } from '../../../lib/wrapped/wrappedCopy';
import { format } from 'date-fns';

interface InitiationCardProps {
  initiationDate: Date | null;
  avatarUrl?: string;
  username?: string;
}

export const InitiationCard: React.FC<InitiationCardProps> = ({
  initiationDate,
  avatarUrl,
  username,
}) => {
  const isHoneymoon = initiationDate
    ? (Date.now() - initiationDate.getTime()) / (1000 * 60 * 60 * 24) < 90
    : false;

  return (
    <WrappedCard className="relative" username={username}>
      <div className="space-y-4 md:space-y-6 relative z-10">
        {/* User avatar */}
        {avatarUrl && (
          <div className="flex justify-center mb-4 md:mb-6">
            <img
              src={avatarUrl}
              alt="User avatar"
              className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-yellow-400 shadow-2xl"
              style={{ objectPosition: 'center top' }}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/avatars/default.png';
              }}
            />
          </div>
        )}
        
        <p className="text-xl md:text-2xl lg:text-3xl text-yellow-200 font-bold mb-4 md:mb-6 drop-shadow-lg px-2">
          You Were Initiated On
        </p>
        {initiationDate ? (
          <>
            <div className="bg-black/60 backdrop-blur-md rounded-2xl p-5 md:p-6 border-2 border-yellow-400/50 shadow-2xl mb-3 md:mb-4">
              <div className="text-4xl md:text-5xl lg:text-6xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent break-words">
                {format(initiationDate, 'MMMM d, yyyy')}
              </div>
            </div>
            {isHoneymoon && (
              <div className="bg-yellow-500/20 backdrop-blur-sm rounded-xl p-3 md:p-4 border-2 border-yellow-400/50">
                <p className="text-base md:text-lg lg:text-xl text-yellow-200 font-semibold italic">
                  {wrappedCopy.cards.initiation.honeymoon}
                </p>
              </div>
            )}
          </>
        ) : (
          <p className="text-base md:text-lg text-yellow-300">Date not available</p>
        )}
      </div>
    </WrappedCard>
  );
};

